/**
 * Hamyon so'rovlari — docs/API.md §6.
 *
 * Muhim nuqta: `POST /wallet/topup` **balansni oshirmaydi**. U faqat
 * invoice yaratadi. Diamond `successful_payment` webhookida qo'shiladi,
 * ya'ni serverda — klient uni faqat qayta so'rab bilib oladi.
 */

import type { TopupRequest, TopupResponse, WalletResponse } from '@voice/api-client';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { ME_KEY } from './useMe';
import { request } from './client';

export const WALLET_KEY = ['wallet'] as const;

export function useWallet() {
  return useQuery({
    queryKey: WALLET_KEY,
    queryFn: () => request<WalletResponse>('/wallet'),
    staleTime: 15_000,
  });
}

export function useTopup() {
  return useMutation({
    mutationFn: (body: TopupRequest) =>
      request<TopupResponse>('/wallet/topup', { method: 'POST', body }),
  });
}

/**
 * To'lovdan keyin balansni yangilaydi.
 *
 * Telegram "to'landi" deb javob qaytarganda bizning webhook hali kelmagan
 * bo'lishi mumkin — ular ikki xil yo'ldan yuradi. Shuning uchun bir marta
 * emas, bir necha marta so'raymiz.
 *
 * Cheklangan urinishlar: cheksiz poll qilish mobil tarmoqda batareyani
 * yeydi va webhook umuman kelmasa ham to'xtamaydi.
 */
const REFRESH_DELAYS_MS = [0, 1_500, 4_000];

export function useBalanceRefresh(): () => void {
  const client = useQueryClient();

  return () => {
    for (const delay of REFRESH_DELAYS_MS) {
      setTimeout(() => {
        void client.invalidateQueries({ queryKey: WALLET_KEY });
        void client.invalidateQueries({ queryKey: ME_KEY });
      }, delay);
    }
  };
}
